import AbstractService from "./abstract.service"
import PlanTransformer, { baseUri } from "@/transformers/plan.transformer"

class PlanService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: PlanTransformer })
  }

  getPlansFull() {
    return this.get("api/plans-full", {
      needsAuth: false,
      transformer: PlanTransformer,
      transformerMethod: "receiveCollection"
    }).then(({ items }) => items)
  }

  getExpirationDateInfo({ planUuid, accountUuid }) {
    return this.get(`/api/plans/downgrade-info/${planUuid}/${accountUuid}`, {
      needsAuth: false,
      transformer: null
    }).then(({ prices }) => prices)
  }
}

const planService = new PlanService()
export default planService
